import { Mui, MuiIcons } from '@osu/react-ui';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectJobs } from '../../services/graphql/slices/jobs-slice';

const visuallyHidden = { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap' };

const failureStatuses = new Set(['failed', 'timed_out', 'aborted', 'pending_redrive'])

export default function JobsIndicator() {
    const [anchor, setAnchor] = useState(null);
    const jobs = useSelector(selectJobs);
    const jobList = Object.entries(jobs).reverse().sort(([, a], [, b]) => (a.status === 'pending') === (b.status === 'pending') ? 0 : a.status === 'pending' ? -1 : 1);
    const pendingCount = jobList.filter(([, job]) => job.status === 'pending').length;
    const additionalItemLength = jobList.length - 5
    
    const liveText =  pendingCount
        ? `${pendingCount} job${pendingCount !== 1 ? 's' : ''} in progress`
        : 'All jobs complete';
        
    return (
        <>
            <span aria-live="polite" aria-atomic="true" style={visuallyHidden}>{liveText}</span>

            <Mui.IconButton
                onClick={(e) => setAnchor(e.currentTarget)}
                color="inherit"
                aria-label="jobs"
                aria-description={pendingCount ? `${pendingCount} job${pendingCount !== 1 ? 's' : ''} in progress, click to view` : jobList.length ? 'View completed jobs' : 'No jobs running'}
                aria-haspopup="dialog"
                sx={{ position: 'relative', marginRight: '.5rem' }}
            >
                <Mui.Badge badgeContent={pendingCount || null} color="warning">
                    {pendingCount > 0 ? <MuiIcons.AssessmentOutlined color="primary" style={{ fontSize: 28 }} /> : <MuiIcons.AssessmentOutlined color="primary" style={{ fontSize: 28 }} />}
                </Mui.Badge>
            </Mui.IconButton>

            <Mui.Popover
                aria-modal="true"
                open={!!anchor}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Mui.List className='padding-2' dense sx={{ minWidth: 260, maxWidth: 500 }}>
                    {jobList.length === 0 ? (
                        <Mui.ListItem>
                            <Mui.ListItemText primary="No jobs running" />
                        </Mui.ListItem>
                    ) : (
                        jobList.slice(0, 5).map(([id, { label, status }]) => (
                            <Mui.ListItem
                                key={id}
                                secondaryAction={
                                    status === 'pending'
                                        ? <Mui.CircularProgress size={18} aria-label="In progress" />
                                        : status === 'done'
                                            ? <MuiIcons.CheckCircleOutline color="success" fontSize="small" />
                                            : failureStatuses.has(status)
                                                ? <MuiIcons.ErrorOutline color="error" fontSize="small" />
                                                : null
                                }
                            >
                                <Mui.ListItemText primary={label} />
                            </Mui.ListItem>
                        ))
                    )}
                    {jobList.length > 5 && (
                        <Mui.ListItem>
                            <Mui.ListItemText secondary={`+ ${additionalItemLength} additional event${additionalItemLength !== 1 ? 's' : ''} performed`} />
                        </Mui.ListItem>
                    )}
                </Mui.List>
            </Mui.Popover>

        </>
    );
}
